<template>
  <div :class="[className]" class="w-full">
    <el-button
      v-if="comingsoon"
      class="connect-button"
      type="primary"
      size="large"
      plain
      disabled
    >
      {{ serviceName }} Coming Soon
    </el-button>

    <el-button
      v-else-if="connecting"
      class="connect-button"
      type="primary"
      size="large"
      plain
      disabled
    >
      Connecting...
    </el-button>

    <el-button
      v-else-if="!connected && !disconnecting"
      class="connect-button"
      type="primary"
      size="large"
      @click="triggerConnect"
    >
      Connect {{ serviceName }} Account
    </el-button>

    <el-button
      v-else-if="disconnecting"
      class="connect-button"
      type="danger"
      size="large"
      plain
      disabled
    >
      Disconnecting Account
    </el-button>

    <el-button
      v-else-if="connected && !disconnecting"
      class="connect-button"
      type="danger"
      size="large"
      @click="triggerDisconnect"
    >
      Disconnect {{ serviceName }} Account
    </el-button>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";

const props = defineProps({
  comingsoon: Boolean,
  connected: Boolean,
  connectFunction: Function,
  disconnectFunction: Function,
  serviceName: String,
  className: String,
});

const connected = ref(props.connected);
const connecting = ref(false);
const disconnecting = ref(false);
const comingsoon = ref(props.comingsoon);

const triggerConnect = () => {
  connecting.value = true;
  props.connectFunction();
  setTimeout(() => {
    connecting.value = false;
    connected.value = true;
  }, 3000);
};

const triggerDisconnect = () => {
  //show alert asking if they're sure
  const confirmDisconnect = confirm(
    `Are you sure you want to disconnect your ${props.serviceName} account?`
  );
  if (!confirmDisconnect) return;
  disconnecting.value = true;
  props.disconnectFunction();
  setTimeout(() => {
    disconnecting.value = false;
    connected.value = false;
  }, 3000);
};
</script>
<style scoped>
.connect-button {
  margin-top: 1rem;
  margin-left: auto;
  /* This corresponds to mt-4 */
  width: 100%;
  /* This corresponds to w-3/4 */
  overflow: hidden;
  /* Hide overflowing content */
  text-overflow: ellipsis;
  /* Display an ellipsis (...) when text overflows */
  white-space: nowrap;
}

@media (min-width: 640px) {
  .connect-button {
    width: 100%;
    /* This corresponds to sm:w-1/2 */
  }
}
</style>
